
import { useState, useEffect } from 'react'

interface RecentResource {
  id: string
  title: string
  description: string | null
  domain: string | null
  file_url: string | null
  last_opened: string
}

export const useRecentResources = () => {
  const [recentResources, setRecentResources] = useState<RecentResource[]>([])

  const addRecentResource = (resource: Omit<RecentResource, 'last_opened'>) => {
    const resourceWithTimestamp = {
      ...resource,
      last_opened: new Date().toISOString()
    }

    setRecentResources(prev => {
      // Remove if already exists
      const filtered = prev.filter(r => r.id !== resource.id)
      // Add to beginning and limit to 3
      return [resourceWithTimestamp, ...filtered].slice(0, 3)
    })

    // Store in localStorage
    const stored = localStorage.getItem('recentResources')
    const existingResources = stored ? JSON.parse(stored) : []
    const updatedResources = [resourceWithTimestamp, ...existingResources.filter((r: RecentResource) => r.id !== resource.id)].slice(0, 3)
    localStorage.setItem('recentResources', JSON.stringify(updatedResources))
  }

  useEffect(() => {
    // Load from localStorage on mount
    const stored = localStorage.getItem('recentResources')
    if (stored) {
      try {
        const resources = JSON.parse(stored)
        setRecentResources(resources)
      } catch (error) {
        console.error('Error loading recent resources:', error)
      }
    }
  }, [])

  return {
    recentResources,
    addRecentResource
  }
}
